import React from 'react'
import { FormGroup, FormText, Input, Label } from 'reactstrap'

const FileInput = ({
  onFileChange,
  accept = ".xlsx, .csv",
  helpText,
  required = true,
  multiple = false // Control multiple file selection (made for HTML-Cleaner)
}) => {

  const handleFileChange = (e) => {
    if (multiple) {
      // For multiple files, pass the entire FileList object
      onFileChange(e.target.files);
    } else {
      // For a single file, pass just the first file object
      onFileChange(e.target.files[0]);
    }
  };

  return (
    <FormGroup>
      <Label for="file-upload" style={{ display: 'block' }}>
        File
      </Label>
      <Input
        id="file-upload"
        type="file"
        className="form-control-alternative"
        style={{ border: '0' }}
        accept={accept}
        required={required}
        multiple={multiple}
        onChange={handleFileChange}
      />
      {helpText && (
        <FormText color="muted" align="left">
          {helpText}
        </FormText>
      )}
    </FormGroup>
  );
};

export default FileInput;